import { CatalogoFilters } from '../../type/filter'

export interface CatalogResponse<TProduct> {
  availableFilters: CatalogoFilters
  products: TProduct[]
  currentPage: number
  pageSize: number
  totalPages: number
  totalProducts: number
}

export const PAGE_SIZE = 12
